import React from "react";
import useResponsive from "../../core/hooks/useResponsive";
import { ThreeRow, TwoColumn, TwoRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";

const UserProductAndSubProductFormContainerStyle = {
  sectionStyle: {
    flex: variables.flex1,
  },
  containerStyle: {
    gap: variables.gapSmall,
  },
  categoryWrapperStyle: {
    border: `1px solid ${variables.grey4}`,
    padding: variables.paddingMedium,
    marginTop: variables.marginMediumLarge,
  },
};

export default function UserProductAndSubProductFormLayout({
  topSection,
  leftBottomSection,
  rightBottomSection,
  topSectionStyle,
  middleSection,
  middleSectionStyle,
}) {
  const responsive = useResponsive();

  return responsive.isSm ? (
    <ThreeRow
      style={UserProductAndSubProductFormContainerStyle.categoryWrapperStyle}
      topSection={topSection}
      topSectionStyle={topSectionStyle}
      middleSection={middleSection}
      middleSectionStyle={middleSectionStyle}
      bottomSection={
        <TwoColumn
          style={UserProductAndSubProductFormContainerStyle.containerStyle}
          leftSection={leftBottomSection}
          leftSectionStyle={
            UserProductAndSubProductFormContainerStyle.sectionStyle
          }
          rightSection={rightBottomSection}
          rightSectionStyle={
            UserProductAndSubProductFormContainerStyle.sectionStyle
          }
        />
      }
    />
  ) : (
    <ThreeRow
      style={UserProductAndSubProductFormContainerStyle.categoryWrapperStyle}
      topSection={topSection}
      topSectionStyle={topSectionStyle}
      middleSection={middleSection}
      middleSectionStyle={middleSectionStyle}
      bottomSection={
        <TwoRow
          style={UserProductAndSubProductFormContainerStyle.containerStyle}
          topSection={leftBottomSection}
          bottomSection={rightBottomSection}
        />
      }
    />
  );
}
